1<template>
    <div class="my-container">
        
        <div class="row">
            <div class="col-lg-12" style="padding: 0px;">
                <div class="card-content" style="margin: 0px;padding-left: 18px;padding-right: 18px;padding-bottom: 0px;">
                    <div class="card-header" style="display: none">
                        <h5 class="card-title">Último Débito</h5>
                    </div>
                    <!-- Dashboard Financeiro Moderno -->
                    <div class="financial-dashboard" v-if="lastInvoice && invoiceDataLoaded">
                        <div class="dashboard-cards-container">
                            <!-- Última Fatura -->
                            <div class="invoice-main-card">
                                <div class="card-title">
                                    <i class="fas fa-file-invoice-dollar"></i>
                                    Última Fatura
                                </div>
                                
                                <div class="invoice-info-grid">
                                    <div class="info-box">
                                        <div class="info-label">Valor</div>
                                        <div class="info-value">{{ brNumber(lastInvoice.E1_VALOR) }}</div>
                                    </div>
                                    
                                    <div class="info-box">
                                        <div class="info-label">Vencimento</div>
                                        <div class="info-value">{{ lastInvoice.E1_VENCREA }}</div>
                                    </div>
                                    
                                    <div class="info-box">
                                        <div class="info-label">Status</div>
                                        <div class="info-value status-value status-pending"
                                                v-if="(lastInvoice.E1_STATUS == 'A' && lastInvoice.E1_BAIXA.split('/')[0].trim() == '') && !estaVencido(lastInvoice.E1_VENCREA)">
                                            A Vencer
                                        </div>
                                        <div class="info-value status-value status-overdue"
                                                v-if="(lastInvoice.E1_STATUS == 'A' || lastInvoice.E1_BAIXA.split('/')[0].trim() == '') && estaVencido(lastInvoice.E1_VENCREA)">
                                            Vencido
                                        </div>
                                        <div class="info-value status-value status-paid"
                                                v-if="(lastInvoice.E1_STATUS == 'B' || lastInvoice.E1_BAIXA.split('/')[0].trim() != '') && parseFloat(lastInvoice.E1_SALDO) == 0">
                                            Baixado
                                        </div>
                                        <div class="info-value status-value status-partial"
                                                v-if="(lastInvoice.E1_STATUS == 'B' || lastInvoice.E1_BAIXA.split('/')[0].trim() != '') && parseFloat(lastInvoice.E1_SALDO) > 0">
                                            Baixado Parcialmente
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Débitos em Atraso -->
                            <div class="debt-card overdue-card" :class="{ 'no-debt': late_count == 0 || late_count == null || late_count == '' }">
                                <div class="card-title">Débitos em Atraso</div>
                                <div v-if="late_count == 0 || late_count == null || late_count == ''" class="debt-content no-debt">
                                    <div class="debt-count">0</div>
                                    <div class="debt-amount">Nenhum débito</div>
                                </div>
                                <div v-else class="debt-content">
                                    <div class="debt-count">{{ late_count }}</div>
                                    <div class="debt-amount">R$ {{ total_late }}</div>
                                </div>
                            </div>

                            <!-- Débitos a Vencer -->
                            <div class="debt-card pending-card" :class="{ 'no-debt': open_count == 0 || open_count == null || open_count == '' }">
                                <div class="card-title">Débitos a Vencer</div>
                                <div v-if="open_count == 0 || open_count == null || open_count == ''" class="debt-content no-debt">
                                    <div class="debt-count">0</div>
                                    <div class="debt-amount">Nenhum débito</div>
                                </div>
                                <div v-else class="debt-content">
                                    <div class="debt-count">{{ open_count }}</div>
                                    <div class="debt-amount">R$ {{ total_open }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Indicador de carregamento para a seção de débitos -->
                    <div class="financial-dashboard loading-state" v-if="!invoiceDataLoaded">
                        <div class="loading-card">
                            <div class="loading-content">
                                <div class="loading-spinner">
                                    <i class="fa fa-spinner fa-spin"></i>
                                </div>
                                <h6 class="loading-text">Carregando Resumo Financeiro...</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
               

        <!-- BaseTable em container separado -->
        <div class="">
            <base-table v-if="tableLoaded" :ref="table" :filters="filters" :crudName="crudName" :newText="newText" :table="table"
                colorBar='5px solid rgb(255,76,65)' :endPoint="endPoint" :enableAdd="false" :enableEdit="true"
                :enableSaveColumns="true" :enableDelete="true" :relationships="relationships" :extras="extras"
                :columns="columns" :enableExtract="true" :orders="orders" :styleHeader="'border-bottom: 5px solid #FF4C41'"
                @boleto="boleto" @danfe="danfe"></base-table>
            <div class="my-card" v-else>
                <div class="text-center" style="padding: 60px 24px;">
                    <span class="fa fa-spinner fa-spin fa-5x"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseTable from "@/components/Layouts/BaseTable.vue";
import env from "@/env";

export default {
    data() {
        return {
            limiteCredito: "...",
            total_late: "...",
            total_open: "...",
            loaded: false,
            tableLoaded: false,
            invoiceDataLoaded: false,
            extras: [],
            pending_invoices: [],
            pending_invoices_total: 0,
            crudName: "Financeiro",
            orders: [
                {
                    name: "",
                    column: "",
                },
                {
                    name: "N° da Nota",
                    column: "E1_NUM",
                },
                {
                    name: "N° da Negociação",
                    column: "C5_MDCONTR",
                },
                {
                    name: "Data de Vencimento",
                    column: "E1_VENCREA",
                    selected: true,
                },
            ],
            filters: [
                {
                    id: "invoiceType",
                    type: "radio",
                    name: "status",
                    label: "Todos",
                    value: "all",
                    checked: true,
                },
                {
                    id: "invoiceType",
                    type: "radio",
                    name: "status",
                    label: "A Vencer",
                    value: "checkOpen",
                },
                {
                    id: "invoiceType",
                    type: "radio",
                    name: "status",
                    label: "Atrasados",
                    value: "checkOverdue",
                },
                {
                    id: "invoiceType",
                    type: "radio",
                    name: "status",
                    label: "Pagos",
                    value: "checkPayed",
                },
                {
                    id: "E1_NUM",
                    type: "text",
                    class: "form-control",
                    name: "E1_NUM",
                    label: "N° Nota/Parcela",
                    value: "",
                    columnSize: "col-3",
                },
                {
                    id: "C5_MDCONTR",
                    type: "contract",
                    class: "form-control",
                    name: "C5_MDCONTR",
                    label: "N° da Negociação",
                    value: "",
                    columnSize: "col-3",
                },
                {
                    name: "C6_NUMPCOM",
                    label: "Pedido do Cliente",
                    value: "",
                    type: "text",
                    applied: false,
                    class: "form-control",
                    columnSize: "col-3",
                },
                {
                    id: "B1_DESC",
                    product_column: "B1_ESPECIE",
                    type: "product",
                    class: "form-control",
                    name: "B1_DESC",
                    label: "Produto",
                    value: "",
                    columnSize: "col-3",
                },
                {
                    id: "E1_VENCREA",
                    type: "date",
                    class: "form-control",
                    name: "E1_VENCREA",
                    label: "Data de Vencimento",
                    value: "",
                    columnSize: "col-3",
                },
                {
                    id: "returned",
                    type: "radio",
                    name: "returned",
                    label: "NF Devolvida",
                    value: "sim",
                    columnSize: "col-3",
                },
            ],
            newText: "",
            table: "invoice-list",
            endPoint: "invoices/",
            relationships: [],
            columns: [
                {
                    reportColumn: { COLUNA: 'NUM NOTA/PARCELA', CAMPO: 'VAZIO' },
                    label: "N° Nota/Parcela",
                    type: "buttonLabel",
                    callbackFunction: "danfe",
                    class: "btn btn-info btn-sm",
                    labelCallback: function (row) {
                        if (row.E1_PARCELA.trim() != "") {
                            return row.E1_NUM + " / " + row.E1_PARCELA;
                        }
                        return row.E1_NUM;
                    },
                    condition: function (row) {
                        if (row) {
                            return row.E1_NUM.trim() && row.C5_LOJAENT.trim() ? false : true;
                        }
                        return false;
                    },
                    conditionShow: function (row) {
                        if (row) {
                            return row.E1_NUM.trim() == "" ? false : true;
                        }
                        return true;
                    },
                },
                {
                    reportColumn: null,
                    label: "Forma de Pagamento",
                    type: "payment_method",
                    callbackFunction: "boleto",
                    class: "",
                    labelCallback: function (row) {
                        if (row.A1_XTIPDOC === "D" || row.A1_XTIPDOC.trim() === "") {
                            return 'Depósito Bancário';
                        } else if(row.A1_XTIPDOC === "B" && (row.E1_PORTADO.trim() == "" || row.E1_BAIXA.split('/')[0].trim() != '' || row.E1_NUMBCO.trim() == "")){
                            return 'Boleto Indisponível';
                        } else if (row.A1_XTIPDOC === "B") {
                            return 'Boleto';
                        } else {
                            return 'Outro';
                        }
                    },
                    condition: function (row) {
                        
                        const arr = ['237', '001', '341', '756', '033'];

                        if (row && arr.indexOf(row.E1_PORTADO) > -1 && row.A1_XTIPDOC === "B" && row.E1_BAIXA.split('/')[0].trim() == '' && row.E1_NUMBCO.trim() != "") {

                            console.log(1);
                            return false;
                        }
                        
                        console.log(2);
                        return true;
                        // return true;
                    },
                    conditionShow:

                        function (row) {
                            // if (row) {
                            //     if (env.isAmbientaly === true) {
                            //         return row.E1_NUMBCO.trim() == "" ? false : true;
                            //         // return row.E1_NUMBCO.trim() == "" ? true : true;
                            //     } else {
                            //         return row.E1_NUMBCO.trim() == "" || row.E1_PORTADO != '341' ? false : true;
                            //     }
                            // }
                            // if (row.E1_NUMBCO.trim() != "" && row.E1_BAIXA.split('/')[0].trim() != '')
                            //     return false;

                            return true;
                        }

                    ,
                },
                /*{
                    label: "Banco",
                    callback: function (row) {
                        if (!row.E1_NUMBCO.trim() == "") {
                            switch (row.E1_PORTADO) {
                                case "237":
                                    return "<img src='/banks/bradesco.png'>";
                                case "001":
                                    return "<img src='/banks/banco_do_brasil.png'>";
                                case "341":
                                    return "<img src='/banks/itau.png'>";
                                case "756":
                                    return "<img src='/banks/sicoob.png'>";
                                case "033":
                                    return "<img src='/banks/santander.jpg'>";
                                default:
                                    return "N/A";
                            }
                        } else {
                            return "N/A";
                        }
                    },
                },
                {
                    label: "Dados Bancários",
                    callback: function (row) {
                        if (row.dados_bancarios) {
                            const arr = row.dados_bancarios.split(" ");
                            return `
                                ${arr[0]} ${arr[1]}<br>
                                ${arr[2]} ${arr[3]}<br>
                                ${arr[4]}<br>
                                <span style="white-space: nowrap">${arr[5]}</span>`;
                        } else {
                            return "";
                        }
                    },
                },*/
                {
                    reportColumn: { COLUNA: 'STATUS', CAMPO: 'VAZIO' },
                    label: "Status",
                    callback: function (row) {
                        var vencto;
                        var today = moment();
                        if (row.E1_VENCTO.trim()) {
                            vencto = moment(row.E1_VENCTO, "DD/MM/YYYY");
                        }

                        var devolucao = row.D2_QTDEDEV;

                        if (devolucao > 0) {
                            return "<span class='badge bg-danger'>NF DEVOLVIDA</span>";
                        }

                        if (today.diff(vencto, "days") >= 1 && row.E1_STATUS == "A" && row.E1_BAIXA.split('/')[0].trim() == '') {
                            return "<span class='badge bg-danger'>Atrasado</span>";
                        }

                        if (row.E1_BAIXA.split('/')[0].trim() == '' && parseFloat(row.E1_SALDO) > 0) {
                            return "<span class='badge bg-info'>A Vencer</span>";
                        } else if (row.E1_BAIXA.split('/')[0].trim() != '' && parseFloat(row.E1_SALDO) > 0) {
                            return "<span class='badge bg-info'>Baixado Parcialmente</span>";
                        } else if (row.E1_BAIXA.split('/')[0].trim() != '' && parseFloat(row.E1_SALDO) == 0) {
                            return "<span class='badge bg-success'>Baixado</span>";
                        }

                        /*
                        switch (row.E1_STATUS) {
                            case "A":
                                return "<span class='badge bg-info'>A Vencer</span>";
                            case "B":
                                return "<span class='badge bg-success'>Baixado</span>";
                            case "R":
                                return "<span class='badge bg-success'>Baixado</span>";
                            default:
                                return "";
                        }
                        */
                    },
                },
                {
                    reportColumn: { COLUNA: 'DATA DE VENCIMENTO', CAMPO: 'E1_VENCREA' },
                    label: "Data de vencimento",
                    callback: function (row) {
                        if (row.E1_VENCREA.trim()) {
                            return moment(row.E1_VENCREA, "DD/MM/YYYY").format("DD/MM/YYYY");
                        }
                    }
                },
                {
                    reportColumn: { COLUNA: 'DIAS PARA VENCIMENTO', CAMPO: 'VAZIO' },
                    label: "Dias para vencimento",
                    callback:

                        function (row) {
                            var t = row.E1_STATUS;
                            if (t.trim() == "B") {
                                return 0;
                            }
                            if (t.trim() == "A") {
                                let t = moment(row.E1_VENCREA, "DD/MM/YYYY").diff(
                                    moment().format("YYYY-MM-DD"),
                                    "days"
                                );
                                return Math.floor(t);
                            }
                            let diff_in_days = moment(row.E1_VENCREA, "DD/MM/YYYY").diff(
                                moment().format("YYYY-MM-DD"),
                                "days"
                            );
                            return Math.abs(diff_in_days);
                        },
                },
                {
                    reportColumn: { COLUNA: 'DATA DO PAGAMENTO', CAMPO: 'VAZIO' },
                    label: "Data do pagamento",
                    callback: function (row) {
                        var E1_BAIXA = row.E1_BAIXA;
                        if (E1_BAIXA.trim() == "") {
                            return "N/A";
                        }

                        var baixa = row.E1_BAIXA.replaceAll("/", "").trim();

                        if (baixa == "") {
                            return baixa;
                        }
                        return moment(row.E1_BAIXA, "DD/MM/YYYY").format("DD/MM/YYYY");
                    },
                },
                {
                    reportColumn: { COLUNA: 'VALOR', CAMPO: 'VAZIO' },
                    label: "Valor",
                    callback: function (row) {
                        return new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                        }).format(row.E1_VALOR);
                    },
                },
                // {
                //     label: "Parcela",
                //     callback: function (row) {
                //         if (row) {
                //             var E1_PARCELA = row.E1_PARCELA;
                //             if (E1_PARCELA.trim() != "") {
                //                 return E1_PARCELA;
                //             } else {
                //                 return "N/A";
                //             }
                //         } else {
                //             return "N/A";
                //         }
                //     },
                // },
                {
                    reportColumn: { COLUNA: 'COND. PAGAMENTO', CAMPO: 'E4_DESCRI' },
                    label: "Cond. pagamento",
                    callback: function (row) {
                        if (row) {
                            var E4_DESCRI = row.E4_DESCRI;
                            if (E4_DESCRI.trim() != "") {
                                return E4_DESCRI;
                            } else {
                                return "N/A";
                            }
                        } else {
                            return "N/A";
                        }
                    },
                },
                {
                    reportColumn: { COLUNA: 'PRODUTO', CAMPO: 'B1_DESC' },
                    label: "Produto",
                    callback: function (row) {
                        if (row.C6_PRODUTO.trim() != "") return row.B1_ESPECIE;
                        else return "N/A";
                    },
                },
                {
                    reportColumn: { COLUNA: 'NUM DO PEDIDO DO CLIENTE', CAMPO: 'C6_NUMPCOM' },
                    label: "N° do pedido do cliente",
                    callback: function (row) {
                        if (row) {
                            var C6_NUMPCOM = row.C6_NUMPCOM;
                            if (C6_NUMPCOM.trim() != "") {
                                return C6_NUMPCOM;
                            } else {
                                return "N/A";
                            }
                        } else {
                            return "N/A";
                        }
                    },
                },
                {
                    reportColumn: { COLUNA: 'FILIAL', CAMPO: 'M0_FILIAL' },
                    label: "Filial",
                    callback: function (row) {
                        if (row) {
                            var string = row.E1_FILIAL;
                            string = string.substring(string.indexOf(" - ") + 2);
                            return string;
                        } else {
                            return "";
                        }
                    },
                },
                {
                    reportColumn: { COLUNA: 'NUM DO PEDIDO', CAMPO: 'C5_NUM' },
                    label: "N° do pedido",
                    callback: function (row) {
                        if (row) {
                            var C5_NUM = row.C5_NUM;
                            if (C5_NUM.trim() != "") {
                                return C5_NUM;
                            } else {
                                return "N/A";
                            }
                        } else {
                            return "N/A";
                        }
                    },
                },
                {
                    reportColumn: { COLUNA: 'NUM DA NEGOCIACAO', CAMPO: 'C5_MDCONTR' },
                    label: "N° da Negociação",
                    callback: function (row) {
                        if (row) {
                            var C5_MDCONTR = row.C5_MDCONTR;
                            if (C5_MDCONTR.trim() != "") {
                                return C5_MDCONTR;
                            } else {
                                return "N/A";
                            }
                        } else {
                            return "N/A";
                        }
                    },
                },
            ],
        };
    }
    ,
    computed: {
        lastInvoice() {
            if (this.pending_invoices != undefined) {
                if (this.pending_invoices.length > 0) {
                    return this.pending_invoices[this.pending_invoices.length - 1];
                }
            }

            return null;
        }
        ,
    }
    ,
    methods: {

        estaVencido(E1_VENCREA) {
            let diff_in_days = moment(E1_VENCREA, "DD/MM/YYYY").diff(
                moment().format("YYYY-MM-DD"),
                "days"
            );
            if (Math.abs(diff_in_days) > 0) {
                return false;
            }
            return true;
        },

        boleto(data) {
            const self = this;

            const user = self
            if(data.A1_XTIPDOC === "B" && (data.E1_PORTADO.trim() == "" || data.E1_BAIXA.split('/')[0].trim() != '' || data.E1_NUMBCO.trim() == "")){
                
                if(user.type_id == 2){

                    self.$toast.error("Boleto não está disponível, entre em contato com o comercial");
                } else {

                    if(data.E1_PORTADO.trim() == ""){

                        self.$toast.error("Boleto não está disponível, entre em contato com o financeiro, pois o título está sem banco definido (E1_PORTADO).");
                    } else if(data.E1_NUMBCO.trim() == ""){
                        
                        self.$toast.error("Boleto não está disponível, entre em contato com o financeiro, pois o título está sem número do banco (E1_NUMBCO).");
                    } else if(data.E1_BAIXA.split('/')[0].trim() != ''){

                        self.$toast.error("Boleto não está disponível, pois o título ja foi baixado (E1_BAIXA).");
                    }
                }
            }

            if ( data.E1_NUMBCO.trim() != '') {

                if (data.E1_PORTADO == '237') {

                    var params = {
                        user_id: self.$store.getters.user.id,
                        num: data.E1_NUM,
                        parcela: data.E1_PARCELA,
                        banco: data.E1_PORTADO
                    };
                    params = JSON.stringify(params);
                    params = btoa(params);

                    this.$router.push("/admin/invoice-list/ticket/" + params);
                    // window
                    //     .open(
                    //         self.$store.state.api + "invoices/boleto?params=" + params,
                    //         "_blank"
                    //     )
                    //     .focus();
                } else {

                    const arr = data.E1_FILIAL.split('-');
                    var params = {
                        user_id: self.$store.getters.user.id,
                        filial: arr[0].trim(),
                        num: data.E1_NUM,
                        parcela: data.E1_PARCELA,
                        banco: data.E1_PORTADO
                    };
                    params = JSON.stringify(params);
                    params = btoa(params);
                    this.$router.push("/admin/invoice-list/ticket/" + params);
                }

            } else {
                // alert("Boleto não disponível para esse título");
            }
        }
        ,
        danfe(data) {
            const self = this;

            if (data.E1_NUM.trim() && data.C5_LOJAENT.trim()) {
                data = btoa(
                    JSON.stringify({
                        nota_fiscal: data.E1_NUM.trim(),
                        loja_ent: data.C5_LOJAENT.trim(),
                        contrato: data.C5_MDCONTR.trim(),
                        filial: data.E1_FILIAL.trim(),
                    })
                );
                this.$router.push("/admin/invoice/danfe/" + data);
            } else {
                alert("DANFE não disponível para esse título");
            }
        }
        ,
        encode(string) {
            return btoa(string);
        }
        ,
        brNumber(number) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
            }).format(number);
        }
        ,
        getLastInvoice() {
            const self = this;
            const api = this.$store.state.api + "invoices/lastInvoice";

            axios
                .get(api)
                .then((response) => {
                    self.pending_invoices = response.data.data.ZOOM;
                    self.late_count = response.data.late.count;
                    self.total_late = response.data.total_late;
                    self.total_open = response.data.total_open;
                    self.open_count = response.data.open.count;
                    self.pending_invoices_total = response.data.data.count;
                    self.invoiceDataLoaded = true;
                    self.getPaymentMethod();
                })
                .catch((error) => {
                    this.$toast.error("Erro na API");
                });
        }
        ,

        getPaymentMethod() {
            // Este método agora é redundante pois a tabela é inicializada independentemente
            // Mantido apenas para compatibilidade, mas não afeta mais o carregamento da tabela
            const self = this;
            self.loaded = true;
        }
        ,
        getCreditLimit() {
            const self = this;
            const api = this.$store.state.api + "invoices/creditLimit";

            axios
                .get(api)
                .then((response) => {
                    self.limiteCredito = response.data.saldo;
                })
                .catch((error) => {
                    this.$toast.error("Erro na API");
                });
        }
        ,

        initializeTable() {
            const self = this;
            
            // Carrega configurações da tabela de forma independente
            const api = this.$store.state.api + "invoices/payment-method";

            axios
                .post(api)
                .then((response) => {
                    self.payment_method = response.data.ZOOM[0]["A1_XTIPDOC"];

                    // Configura colunas baseado no método de pagamento
                    if (self.payment_method == "B") {
                        // Configurações para boleto
                        // self.columns.splice(3, 1);
                    } else {
                        // Configurações para outros métodos
                        // self.columns.splice(3, 1);
                    }
                    
                    // Habilita a tabela
                    self.tableLoaded = true;
                })
                .catch((error) => {
                    this.$toast.error("Erro na API");
                    // Mesmo com erro, permite carregar a tabela
                    self.tableLoaded = true;
                });
        }
        ,
    }
    ,
    mounted() {
        const self = this;
        // this.getPendingInvoices();
        // this.getCreditLimit();
        
        // Carrega dados da lista de débitos de forma independente
        this.getLastInvoice();
        
        // Inicializa a tabela de forma independente
        this.initializeTable();
    }
    ,
    components: {
        BaseTable,
    }
    ,
}
    ;
</script>

<style scoped>
/* Estilos do Container Principal - Mesmo padrão do BaseTable */
.my-container {
    padding: 16px;
    background: #f8f9fa;
    min-height: 100vh;
    width: 100%;
}

.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
}

.card-content {
    padding: 20px 24px;
    width: 100% !important;
}

/* Dashboard Financeiro - Mantendo estilo anterior */
.financial-dashboard {
    width: 100% !important;
    margin-bottom: 12px;
    padding: 0;
}

.dashboard-cards-container {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 8px;
    align-items: stretch;
}

/* Card da Última Fatura - Estilo anterior */
.invoice-main-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    color: white;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.invoice-main-card::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transform: translate(20px, -20px);
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 8px 0;
    color: white;
    display: flex;
    align-items: center;
    gap: 6px;
}

.card-title i {
    font-size: 14px;
}

.invoice-info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.info-box {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.info-label {
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.3px;
    opacity: 0.8;
    line-height: 1;
}

.info-value {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
}

.status-value {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 6px;
    border-radius: 6px;
    font-size: 9px !important;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    line-height: 1;
    border: 1px solid;
    width: fit-content;
}

/* Status específicos com cores */
.status-pending {
    background: rgba(255, 193, 7, 0.2);
    color: #FFD700;
    border-color: rgba(255, 193, 7, 0.5);
}

.status-overdue {
    background: rgba(220, 53, 69, 0.2);
    color: #ff6b6b;
    border-color: rgba(220, 53, 69, 0.5);
}

.status-paid {
    background: rgba(40, 167, 69, 0.2);
    color: #51cf66;
    border-color: rgba(40, 167, 69, 0.5);
}

.status-partial {
    background: rgba(23, 162, 184, 0.2);
    color: #74c0fc;
    border-color: rgba(23, 162, 184, 0.5);
}

/* Cards de Débitos - Estilo anterior */
.debt-card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-left: 3px solid;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    height: 100%;
}

.debt-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.debt-card::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.05), transparent);
    border-radius: 50%;
    transform: translate(15px, -15px);
}

.overdue-card {
    border-left-color: #dc3545;
}

.pending-card {
    border-left-color: #ffc107;
}

.debt-card.no-debt {
    border-left-color: #28a745;
}

.debt-card .card-title {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    line-height: 1;
    justify-content: flex-start;
    width: 100%;
}

.debt-content {
    display: flex;
    flex-direction: column;
    gap: 1px;
    flex: 1;
    width: 100%;
    justify-content: center;
}

.debt-count {
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
}

.debt-amount {
    font-size: 11px;
    font-weight: 500;
    opacity: 0.8;
    line-height: 1.2;
}

/* Estados dos cards de débito */
.overdue-card .debt-count {
    color: #dc3545;
}

.pending-card .debt-count {
    color: #ffc107;
}

.debt-card.no-debt .debt-count {
    color: #28a745;
}

.debt-card.no-debt .debt-amount {
    color: #28a745;
    font-weight: 600;
}

/* Loading State - Compacto */
/* .loading-state {
    margin-bottom: 12px;
} */

.loading-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 10px;
    padding: 20px 16px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.loading-spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
}

.loading-text {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    margin: 0;
}

/* Responsividade - Compacta */
@media (max-width: 768px) {
    .my-container {
        padding: 12px;
    }
    
    .card-content {
        padding: 16px 20px;
    }
    
    .dashboard-cards-container {
        grid-template-columns: 1fr;
        gap: 6px;
    }
    
    .invoice-info-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 6px;
    }
    
    .invoice-main-card {
        padding: 12px;
    }
    
    .debt-card {
        padding: 12px;
    }
}

@media (max-width: 576px) {
    .my-container {
        padding: 8px;
    }
    
    .card-content {
        padding: 12px 16px;
    }
    
    .card-title {
        font-size: 12px;
    }
    
    .invoice-info-grid {
        grid-template-columns: 1fr;
        gap: 4px;
    }
    
    .info-value {
        font-size: 12px;
    }
    
    .debt-count {
        font-size: 16px;
    }
    
    .debt-amount {
        font-size: 11px;
    }
}
</style>
